import { ReactNode, forwardRef } from 'react';
import { CheckboxProps, Checkbox, Text } from 'theme-ui';

interface CheckboxControlProps extends CheckboxProps {
  label?: ReactNode;
}

const CheckboxControl = forwardRef<HTMLInputElement, CheckboxControlProps>(({ className, label, ...props }: CheckboxControlProps, ref) => {
  return (
    <label
      className={className}
      sx={{
        display: 'flex',
        alignItems: 'center'
      }}>
      <Checkbox
        ref={ref}
        {...props}
        sx={{ mr: 1 }}
      />
      {label && <Text>{label}</Text>}
    </label>
  )
});

export default CheckboxControl;
